import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';

import { Document } from '../_models/document';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { AppConfig } from 'src/assets/config/config/app-config';
import { AuthenticationService } from './authentication.service';
import { ISearchForm } from '../_models/search';


@Injectable({ providedIn: 'root' })
export class DocumentService {
  workflowcategories: string[] = ['Workflow Category'];
  apiUrl: StringMap;
  captureApiUrl: string;
  exportUrl: string;
  private selectedDocuments: BehaviorSubject<any>;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private userService: AuthenticationService,
    private config: AppConfig
  ) {
    this.apiUrl = this.config.getConfig('apiUrl');
    this.exportUrl = this.config.getConfig('exportLink');
    this.captureApiUrl = this.config.getConfig('captureApiUrl');
    this.selectedDocuments = new BehaviorSubject<any>([]);
  }
  revertUpload(documentId, version, activeVersion) {
    let revertUrl =
      activeVersion == -1
        ? this.apiUrl +
          `/documents/upload/revert?document_id=` +
          documentId +
          `&version=` +
          version
        : this.apiUrl +
          `/documents/upload/revert?document_id=` +
          documentId +
          `&version=` +
          version +
          '&last_active=' +
          activeVersion;

    return this.http.delete(revertUrl).pipe();
  }
  uploadDocument(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/upload`, req)

      .pipe();

  }

  uploadToS3(url, file): Observable<any> {
    return this.http.put<any>(url, file, { observe: 'response' }).pipe();
  }

  completeMultipartUpload(request) {
    return this.http
      .post<any>(this.apiUrl + `/documents/multipart/complete`, request)
      .pipe();
  }

  uploadDocumentDirect(request: FormData) {
    let currentUser = this.userService.currentUserValue;
    let token = currentUser.token;
    let requestHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + token,
      'dms-user': currentUser.username,
    });
    console.log('token', token);
    return this.http
      .post(this.apiUrl + `/documents/upload/direct`, request, {
        headers: requestHeaders,
      })
      .pipe(catchError(this.handleError('Upload Document Direct')));
  }

  uploadDocumentVersionDirect(request: FormData) {
    let currentUser = this.userService.currentUserValue;
    let token = currentUser.token;
    let requestHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + token,
      'dms-user': currentUser.username,
    });
    console.log('token', token);
    return this.http
      .post(this.apiUrl + `/documents/upload-version/direct`, request, {
        headers: requestHeaders,
      })
      .pipe(catchError(this.handleError('Upload Document Version Direct')));
  }

  assignOwner(payLoad) {
    return this.http
      .put<any>(this.apiUrl + `/documents/capture/assign`, payLoad)

      .pipe();

  }

  getAllCaptureDocuments(): Observable<any> {
    var url = this.apiUrl + `/documents/capture/get`;
    return this.http.get<Document[]>(url).pipe();
  }

  exportDocuments(req: any): Observable<any> {  
    this.snackBar.open(
      "Export Job is running in the background. The status of export can be tracked and downloaded from 'Export Status' tab",
      'Close',
      {
        duration: 20000,
      }
    );  
    return this.http
      .post<any>(this.apiUrl + `/documents/export-documents`, req)
      .pipe(catchError(this.handleError<any>('exportDocument')));
  }

  exportDocumentsLink(req: any): Observable<any> {  
    this.snackBar.open(
      "Export Job is running in the background. The status of export can be tracked and downloaded from 'Export Status' tab",
      'Close',
      {
        duration: 20000,
      }
    );  
    return this.http
      .post<any>(this.apiUrl + `/documents/export/document-link`, req)
      .pipe(catchError(this.handleError<any>('exportDocumentLink')));
  }

  getExportStatus(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/export-status?offset=0&limit=1000`)
      .pipe(catchError(this.handleError<any>('exportStatus')));
  }

   getBulkUpdateStatus(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/bulkOperations/task/screen/status`)
      .pipe(catchError(this.handleError<any>('bulkUpdateStatus')));
  }

  getDownloadLink(fileName): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/download-export/${fileName}`)
      .pipe(catchError(this.handleError<any>('downloadLink')));
  }

  indexDocumentMetadata(req: any): Observable<any> {
    var requestObject = {
          name: this.apiUrl + `/documents/index`,
          status: 'started'
        }
    this.userService.ongoingAPIRequestSubject.next(requestObject);
    return this.http
      .put<any>(this.apiUrl + `/documents/index`, req)
      .pipe(map(resp => {
        var requestObject = {
          name: this.apiUrl + `/documents/index`,
          status: 'ended'
        }
        this.userService.ongoingAPIRequestSubject.next(requestObject);
        return resp;
      }),catchError(this.handleError<any>('indexDocumentMetadata')));
  }

  updateWaterRightReference(documentId: string): Observable<any> {
    const request = {
      document_id: documentId
    };
    return this.http
      .post<any>(this.apiUrl + `/documents/waterright/reference/update`, request)
      .pipe(catchError(this.handleError<any>('updateWaterRightReference')));
  }

  getLegacyIndexDocuments(req: any, limit, offset): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/legacy?limit=${limit}&offset=${offset}`, req)
      .pipe(catchError(this.handleError<any>('getLegacyIndexDocuments')));
  }

  saveInterimMetadata(req: any): Observable<any> {
    var requestObject = {
          name: this.apiUrl + `/documents/capture/meta-data/save`,
          status: 'started'
        }
    this.userService.ongoingAPIRequestSubject.next(requestObject);
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/meta-data/save`, req)
      .pipe(map(resp => {
        var requestObject = {
          name: this.apiUrl + `/documents/capture/meta-data/save`,
          status: 'ended'
        }
        this.userService.ongoingAPIRequestSubject.next(requestObject);
        return resp;
      }), catchError(this.handleError<any>('saveInterimDocumentMetadata')));
  }

  updateMetadata(req: any): Observable<any> {
    var requestObject = {
          name: this.apiUrl + `/bulkOperations/task/batch`,
          status: 'started'
        }
    this.userService.ongoingAPIRequestSubject.next(requestObject);
    return this.http
      .post<any>(this.apiUrl + `/bulkOperations/task/batch`, req)
      .pipe(map(resp => {
        var requestObject = {
          name: this.apiUrl + `/bulkOperations/task/batch`,
          status: 'ended'
        }
        this.userService.ongoingAPIRequestSubject.next(requestObject);
        return resp;
      }),catchError(this.handleError<any>('updateDocumentMetadata')));
  }

  copyMetadata(req: any): Observable<any> {
    var requestObject = {
          name: this.apiUrl + `/bulkOperations/task/screen`,
          status: 'started'
        }
    this.userService.ongoingAPIRequestSubject.next(requestObject);
    return this.http
      .post<any>(this.apiUrl + `/bulkOperations/task/screen`, req)
      .pipe(map(resp => {
        var requestObject = {
          name: this.apiUrl + `/bulkOperations/task/screen`,
          status: 'ended'
        }
        this.userService.ongoingAPIRequestSubject.next(requestObject);
        return resp;
      }),catchError(this.handleError<any>('copyDocumentMetadata')));
  }

  bulkMetadataSearchForms(): Observable<any> {
    return this.http
      .get<ISearchForm[]>(this.apiUrl + `/search/forms/get/Bulk Metadata Search`)
      .pipe();
  }

  validateMetadata(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/meta-data/validate`, req)
      .pipe(catchError(this.handleError<any>('validateDocumentMetadata')));
  }

  viewCaptureDocument(documentId) {
    return this.http
      .get<any>(this.apiUrl + `/documents/capture/view/` + documentId)
      .pipe();
  }

  captureDocument(req: any): Observable<any> {
    var requestObject = {
          name: this.apiUrl + `/documents/capture`,
          status: 'started'
        }
    this.userService.ongoingAPIRequestSubject.next(requestObject);
    return this.http
      .post<any>(this.apiUrl + `/documents/capture`, req)
      .pipe(map(resp => {
        var requestObject = {
          name: this.apiUrl + `/documents/capture`,
          status: 'ended'
        }
        this.userService.ongoingAPIRequestSubject.next(requestObject);
        return resp;
      }),catchError(this.handleError<any>('uploadDocument')));
  }

  uploadDocumentVersion(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/upload-version`, req)

      .pipe();

  }

  updateDocumentMetadata(req: any): Observable<any> {
    return this.http
      .put<any>(this.apiUrl + `/documents/update`, req)

      .pipe();

  }

  updateDocumentTitle(req: any): Observable<any> {
    return this.http
      .put<any>(this.apiUrl + `/documents/update-title`, req)

      .pipe();

  }

  updateCategoryForDocument(req: any): Observable<any> {
    return this.http
      .put<any>(this.apiUrl + `/documents/update/full-suite`, req)

      .pipe();

  }

  getConfigurationByKey(key: string): Observable<any> {
    return this.http.get<any>(this.apiUrl + `/settings/get/` + key).pipe();
  }

  uploadFileToS3(uploadUrl, file): Observable<any> {
    console.log('AWS');
    var formData = new FormData();
    Object.keys(uploadUrl.fields).forEach((key) => {
      formData.append(key, uploadUrl.fields[key]);
    });
    formData.append('file', file);

    // let requestHeaders = new HttpHeaders({
    //   'Content-Type' : 'multipart/form-data'
    // });
    // return this.http.post<any>(uploadUrl.url, formData, { headers: requestHeaders}).pipe();
    return this.http.post<any>(uploadUrl.url, formData).pipe();
    
  }

  uploadFileToS3Capture(idx, uploadUrl, file): Observable<any> {
    console.log('AWS');
    var formData = new FormData();
    Object.keys(uploadUrl.fields).forEach((key) => {
      formData.append(key, uploadUrl.fields[key]);
    });
    formData.append('file', file);
    const req = new HttpRequest('POST', uploadUrl.url, formData, {
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(req).pipe();
  }

  uploadFileToGCP(uploadUrl, file) {
    var formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(uploadUrl, formData).pipe();
  }

  uploadFileToGCPCapture(idx, uploadUrl, file) {
    var formData = new FormData();
    formData.append('file', file);
    const req = new HttpRequest('POST', uploadUrl, formData, {
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(req).pipe();
  }

  uploadFileToAzure(uploadUrl, file, azureMetaData): Observable<any> {
    console.log('Azure');
    var formData = new FormData();
    formData.append('file', file);
    let header = new HttpHeaders();
    header = header.append('x-ms-blob-type', 'BlockBlob');
    header = header.append('x-ms-blob-content-type', file.type);
    for (const [k, v] of Object.entries(azureMetaData)) {
      header = header.append(`${k}`, `${v}`);
    }
    return this.http.put(uploadUrl.url, file, { headers: header }).pipe();
  }

  uploadFileToAzureCapture(
    idx,
    uploadUrl,
    file,
    azureMetaData
  ): Observable<any> {
    console.log('Azure');
    var formData = new FormData();
    formData.append('file', file);
    let header = new HttpHeaders();
    header = header.append('x-ms-blob-type', 'BlockBlob');
    header = header.append('x-ms-blob-content-type', file.type);
    for (const [k, v] of Object.entries(azureMetaData)) {
      header = header.append(`${k}`, `${v}`);
    }
    const req = new HttpRequest('PUT', uploadUrl.url, file, {
      reportProgress: true,
      responseType: 'json',
      headers: header,
    });
    console.log(header);
    return this.http.request(req).pipe();
  }

  getByCategory(categoryId, offset): Observable<any> {
    return this.http
      .get<any>(
        this.apiUrl +
          `/categories/` +
          categoryId +
          `/get-documents?offset=` +
          offset +
          `&limit=200`
      )
      .pipe();
  }

  getDuplicateByCategory(categoryId, offset): Observable<any> {
    return this.http
      .get<any>(
        this.apiUrl +
          `/documents/duplicate/get/` +
          categoryId +
          `?offset=` +
          offset +
          `&limit=200`
      )
      .pipe();
  }

  viewDocument(documentId): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/view/` + documentId)
      .pipe();
  }

  viewVersionDocument(documentId, versionNumber) {
    return this.http
      .get<any>(
        this.apiUrl +
          `/documents/view-version/` +
          documentId +
          `/` +
          versionNumber
      )
      .pipe();
  }

  checkFileExistsInS3(fileUrl) {
    return new Promise((resolve, reject) => {
      this.http.get(fileUrl).toPromise().then(resp => {        
        resolve(fileUrl);
      }).catch(err => {
        if (err.status == 200) {
          resolve(fileUrl);
        } else {
          reject(err);
        }
      });
    });
  }

  getLegacyIndexDocumentsPromise(req: any, limit, offset) {
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/legacy?limit=${limit}&offset=${offset}`, req).toPromise();
  }


  lockDocument(documentId): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/lock/` + documentId)
      .pipe();
  }

  unlockDocument(documentId): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/unlock/` + documentId)
      .pipe();
  }

  getDocumentDetails(documentId: String): Observable<Document> {
    var url = this.apiUrl + `/documents/get/` + documentId;
    return this.http
      .get<Document>(url)
      .pipe(catchError(this.handleError<Document>('getDocumentDetails')));
  }

  getDocumentVersions(documentId) {
    var url = this.apiUrl + `/documents/get/` + documentId + `/versions`;
    return this.http
      .get(url)
      .pipe(catchError(this.handleError('Get Document Versions Failed')));
  }

  notify(message: string): void {
    this.snackBar.open(message, '', { duration: 5000 });
  }

  deleteDocument(documentId, payload) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: payload,
    };
    return this.http
      .delete(this.apiUrl + `/documents/delete/` + documentId, options)
      .pipe();
  }

  deleteVersion(payload) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: payload,
    };
    return this.http
      .delete<any>(this.apiUrl + `/documents/delete-version`, options)
      .pipe();
  }

  activateVersion(payload) {
    return this.http
      .put<any>(this.apiUrl + `/documents/activate-version`, payload)
      .pipe(catchError(this.handleError<any>('Unable to Activate Version')));
  }

  getDocumentAudit(documentId) {
    return this.http
      .get<any>(this.apiUrl + `/reports/audit/document/` + documentId)
      .pipe(catchError(this.handleError('Get Audit details failed')));
  }

  getComments(docID) {
    return this.http
      .get<any>(this.apiUrl + `/documents/comments/` + docID)
      .pipe(catchError(this.handleError('Get Comments Failed')));
  }

  addComment(payload) {
    return this.http
      .post<any>(this.apiUrl + `/documents/comments/add`, payload)
      .pipe(catchError(this.handleError('Adding Comment Failed')));
  }

  retrieveGlacierDocuments(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/retrieve`, req)
      .pipe(catchError(this.handleError<any>('retrieveGlacierDocuments')));
  }

  getGlacierStatus(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/retrieve-status?offset=0&limit=1000`)
      .pipe(catchError(this.handleError<any>('retrieve-Glacier-status')));
  }

  getDuplicates(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/documents/staging/findduplicates/`)
      .pipe(catchError(this.handleError<any>('finding-duplicates')));
  }

  redactKeywordsOnDocument(payload) {
    const options = {
      headers: new HttpHeaders({
        Authorization: 'Basic cG5jX2FkbWluOiNQYXNzd29yZEEx',
      }),
      body: payload,
    };
    return this.http
      .post(this.captureApiUrl + `/documents/redact`, options)
      .pipe();
  }

  private handleError<T>(operation = 'operation', result?: T) {
    //alert(JSON.stringify(err));
    //o: T;
    //alert(typeof o);
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      var requestObject = {
          name: error.url,
          status: 'ended'
      }
      this.userService.ongoingAPIRequestSubject.next(requestObject);
        // this.snackBar.open(String(error).replace('error:', 'ERROR:  '), '', {
        //   duration: 5000,
        // });

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
      //return result;
    };
  }

  getRedactionStatus(documentId) {
    const options = {
      headers: new HttpHeaders({
        Authorization: 'Basic cG5jX2FkbWluOiNQYXNzd29yZEEx',
      }),
    };
    return this.http
      .get<any>(
        this.captureApiUrl + `document/redact/status?vaultId=` + documentId,
        options
      )
      .pipe();
  }

  sendDocumentForRedaction(payload) {
    console.log('sendDocumentForRedaction');
    // const options = {
    //     headers: new HttpHeaders({
    //         'Authorization': 'Basic cG5jX2FkbWluOiNQYXNzd29yZEEx'
    //     }),
    //     body: payload
    // }
    return this.http
      .post<any>(this.captureApiUrl + 'document/redact', payload)
      .pipe();
  }

  addDocumentToSelectedDocuments(docId: string) {
    const arr = [...this.selectedDocuments.value];
    arr.push(docId);
    this.selectedDocuments.next(arr);
  }

  addDocumentsToSelectedDocuments(docsId: string[]) {
    const tempArr = [...this.selectedDocuments.value];
    for (let i = 0; i < docsId.length; i++) {
      if (tempArr.indexOf(docsId[i]) == -1) {
        tempArr.push(docsId[i]);
      }
    }
    this.selectedDocuments.next(tempArr);
  }

  removeDocumentFromSelectedDocuments(docId: string) {
    const arr = [...this.selectedDocuments.value];
    const indOfDoc = arr.indexOf(docId);
    indOfDoc === -1 ? null : arr.splice(indOfDoc, 1);
    this.selectedDocuments.next(arr);
  }

  removeDocumentsFromSelectedDocuments(docsId: string[]) {
    const tempArr = [...this.selectedDocuments.value];
    for (let i = 0; i < docsId.length; i++) {
      let tempInd = tempArr.indexOf(docsId[i]);
      if (tempInd != -1) {
        tempArr.splice(tempInd, 1);
      }
    }
    this.selectedDocuments.next(tempArr);
  }

  generateShareLink(docId, timeInMinutes){
    let url = this.apiUrl+"/documents/share/"+docId+"/"+timeInMinutes
    return this.http.get(url)
    .pipe(catchError(this.handleError('Get Share Link')));
  }

  removeAllDocumentsFromSelectedDocuments() {
    const tempArr = [];
    this.selectedDocuments.next(tempArr);
  }

  getAllSelectedDocuments() {
    return this.selectedDocuments.asObservable();
  }


  getQuestionAnswer(payload) {
    let url = this.config.getConfig("genAIEndpoint")+"/documents/qna"
    return this.http.post<any>(url, payload)
  }

}
